/* eslint-disable no-use-before-define */
import React from 'react'
import { show, cleanObject, arrayFrom } from '../twd'

const isInvType = (s) => s.indexOf('holdInvType')>=0

export default ({Last}) => {
    const cs = Last.value.searchCriteria || []

    let singleInvType = cs
        .filter((c) => isInvType(c.code))
        .length < 2

    let ps = Last.value.params || {}
    let isCusipSearch = !('holdInvType' in ps) && ('holdCusip' in ps)

    return <React.Fragment>{
        cs
        .map(updateCriteriaDescription)
        .filter(Boolean)
        .map((a,i) => {
            let f = isInvType(a.code) && (singleInvType || isCusipSearch)
            let cls = 'tag ' + (f ? '' : 'tag-dismissible')

            return <button
                data-name="offerings-criteria"
                data-label={a.description}
                key={i}
                className={cls}
                onClick={() => {
                    if (f) return
                    onRemoveCriteria(Last, a)
                }}
            >{a.description}</button>
        })
    }</React.Fragment>
}

const identityFn = (a) => a

const updateCriteriaDescription = (a = {}) => {
    let [key,value] = String(a.code).split('-')
    let fn = CRITERIA_DESCRIPTION_UPDATER[key] || identityFn
    let description = fn(a.description, value)
    if (!description) return

    return { ...a, description }
}

const CRITERIA_DESCRIPTION_UPDATER = {
    holdInvType: (a) => 'Securities: ' + a,
    holdIssue: (a) => 'Issuer: ' + a,
    offeringType: (a) => 'Market: ' + (a==='Primary' ? 'New Issue' : a),

    holdCouponPayFrequency: (a) => 'Coupon: ' + a,
    holdCouponPayMonths: (a) => 'Coupon: ' + a,
    holdCouponTypeCode: (a) => 'Coupon: ' + a,

    holdCorpSectorCode: (a) => a.replace('Corp-', 'Sector: '),
    holdCorpType: (a) => 'Type: ' + a,
    holdConvertible: (a) => 'Type: ' + a,
    holdDrnk: (a) => 'Debt: ' + a.replace('Other DRNK', 'Other'),
    holdSymbol: (a) => 'Symbol: ' + a,

    holdState: (a) => 'State: ' + a,
    holdMuniType: (a) => 'Category: ' + a.replace('Muni-',''),
    holdRefundInd: (a) => 'Category: ' + a,
    holdRefundType: (a) => 'Category: ' + a,
    holdTaxable: (a) => 'Tax: ' + a,
    holdAltMinTax: (a) => 'Tax: ' + a,
    holdStateTaxExempt: (a) => 'Tax: ' + a.replace('St-Tax', 'State-Tax').replace('St-Exempt','State-Exempt'),
    holdUseOfProceeds: (a) => 'Proceeds: ' + a.replace('Muni-', ''),
    holdIssueType: (a) => 'Env: ' + a,


    holdBlueSkyStateCD: (a, v)  => !v ? '' : a.replace('Blue Sky', 'Blue Sky State:'),
    holdFdicNum: (a) => 'FDIC ' + a,

    holdAgencyType: (a) => 'Issuer: ' + a,
    holdTreasuryType: (a) => 'Type: ' + a,

    holdMaturity: (a) => a.replace('Mat:', 'Maturity:'),
    holdCoupon: (a) => a.replace('Cpn:', 'Coupon:'),
    clientPrice: (a) => a.replace('Client Price:','Price:'),

    holdCallableInd: (a) => 'Call: ' + a,
    holdWholeCallInd: (a) => 'Call: ' + a,
    holdPutableInd: (a) => 'Put: ' + a,
    holdPutType: (a) => 'Put: ' + a,
    holdNextSink: (a) => 'Other: ' + a,
    holdErpInd: (a) => 'Other: ' + a,
}


const onRemoveCriteria = (Last, {code}) => {

    let [k, v] = (() => {
        let arr = code.split('-')
        return [arr.shift(), arr.join('-')]
    })()

    let ks = []
    if (k==='offeringType') {
        ks.push(['primarySecondary', v])
    }
    else if (k==='offeringNewToday') {
        v = v==='Y'
    }
    else if (k==='holdCusip') {
        ks.push(['holdIdentifiers'])
    }
    else if (k==='holdPutableInd' && v==='Y') {
        ks.push(
            ['holdPutType', 'MAN'],
            ['holdPutType', 'COND'],
            ['holdPutType', 'SUR'])
    }
    else if (k==='holdRefundInd' && v==='Y') {
        ks.push(
            ['holdRefundType', 'PRE'],
            ['holdRefundType', 'ETM'])
    }
    else if (k==='holdTaxable' && v==='Y') {
        ks.push(['holdTaxable', 'BAB'])
    }
    else if (k==='holdMoodyRating' || k==='holdSpRating') {
        ks.push(['respectSplitRating', true])
    }
    ks.push([k,v])

    let ps = {...(Last.clone().params || {})}
    let f = removeCriteria(ps, ks)
    if (!f) return

    show('offerings', Object.assign({
        searchParams: cleanObject(ps),
        _ts: Date.now(),
        from: Last.value.from
    }))
}

const removeCriteria = (params, keyValues) => {
    let removed = false
    arrayFrom(keyValues).filter(Boolean).forEach( (a) => {
        let [key, value] = a

        let p = params[key]
        var b = false
        if (!p) {
            b = (delete params[key + 'Min'] + delete params[key + 'Max'])>0
        }
        else if (Array.isArray(p)) {
            let i = p.indexOf(value)
            b = p.splice(i,1).length > 0
        }
        else if (p && p===value) {
            b = (delete params[key])>0
        }
        else {
            let arr = String(p).split(',')
            let i = arr.indexOf(value)
            b = arr.splice(i,1).length > 0
            if (b) {
                params[key] = arr.join(',')
            }
        }
        removed = removed || b
    })
    return removed
}


// WEBPACK FOOTER //
// ./src/offerings/criteria.js